/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  getPersonalSession(inboxId) {
    return axios.get(`${this.baseUrl()}/whatsapp/session`, {
      params: { inbox_id: inboxId },
    });
  }

  createPersonalSession({ inboxId }) {
    return axios.post(`${this.baseUrl()}/whatsapp/session`, {
      inbox_id: inboxId,
    });
  }

  deletePersonalSession({ inboxId }) {
    return axios.delete(`${this.baseUrl()}/whatsapp/session`, {
      data: { inbox_id: inboxId },
    });
  }
}

export default new WhatsappChannel();
